export const isNil = (value: any) => {
  return value === undefined || value === null
}
